export const usmle2InternalModule = {
  id: "internal",
  title: "Internal Medicine",
  sections: [
    {
      type: "text",
      content:
        "Chest pain: stabilize and treat ACS when high risk; trend troponins and ECGs.",
    },
    {
      type: "question",
      text: "First step in unstable chest pain with STEMI on ECG?",
      options: ["Reassurance", "Immediate reperfusion", "Outpatient follow-up", "NSAIDs only"],
      correct: 1,
      explanation: "STEMI requires immediate reperfusion therapy.",
    },
  ],
};
